import type { SelectHTMLAttributes } from 'react';

/** Native select with a consistent chevron, focus ring and disabled state.
 * Keeps browser keyboard/mobile behaviour while centralising ERP dropdown UI. */
export function AppSelect({ className = '', children, ...props }: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <span className={`app-select ${className}`}>
      <select {...props}>{children}</select>
      <svg className="app-select-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6" /></svg>
    </span>
  );
}
